export const orderStatusEnums = Object.freeze({
  NEW: "NEW",
  PRESCRIBED: "PRESCRIBED",
  ASSIGNED_RX: "ASSIGNED_RX",
  NO_RX: "NO_RX",
  REFUNDED: "REFUNDED",
});
